module.exports = __webpack_public_path__ + "static/media/arrow-left.e166c741.svg";